export enum settingsTypes {
  FETCH_SETTINGS_REQUEST = "FETCH_SETTINGS_REQUEST",
  FETCH_SETTINGS_SUCCESS = "FETCH_SETTINGS_SUCCESS",
  FETCH_SETTINGS_FAILURE = "FETCH_SETTINGS_FAILURE",
}